import {
  ComponentService,
  DataTransmissionService,
  GocooEngineConfig,
  MessageService,
  ResponseDataModel,
  ShowDefaultDialogService,
} from '@ktvs8/gocoo-engine-front-end';

export namespace ApplicationUserUtility {
  /**
   * ログインユーザーが法務・コンプライアンスかどうかを判定する
   * @returns
   */
  export function loginUserIsLegal() {
    differenceUserRole();
    return GocooEngineConfig.loginUser.userRole === UserRole.Legal;
  }

  /**
   * ログインユーザーが法務・コンプライアンスかどうかを判定する
   * @returns
   */
  export function loginUserIsProduction() {
    differenceUserRole();
    return GocooEngineConfig.loginUser.userRole === UserRole.Production;
  }

  /**
   * ログインユーザーが金額を表示できるかどうかを判定する
   *
   * @returns
   * true : 金額を表示できる
   */
  export function canShowPrice() {
    return !loginUserIsLegal();
  }

  /**
   * DBでに登録されているユーザーの権限とローカルで実装しているユーザーの権限の差分を取得する
   *
   * @returns
   * 差異がある場合はエラーをスローする
   */
  export function differenceUserRole() {
    const dbRoleList = GocooEngineConfig.environment.applicationUser.roleList.map((role) => role.RoleKey);
    //　ローカルで実装しているユーザーの権限を取得
    const localRoleList = Object.values(UserRole);

    if (localRoleList.length !== dbRoleList.length) {
      throw new Error(`ローカルで実装しているユーザーの権限の数とDBに登録されているユーザーの権限の数が一致しません。`);
    }

    localRoleList.forEach((localRole, index) => {
      if (!dbRoleList.includes(localRole)) {
        throw new Error(
          `ローカルで実装しているユーザーの権限にDBに登録されていない権限が含まれています。: ${localRole}`
        );
      }

      if (localRole !== dbRoleList[index]) {
        throw new Error(`ローカルで実装しているユーザーの権限とDBに登録されているユーザーの権限の順番が一致しません。`);
      }
    });
  }

  /**
   * プロデューサーのリストを取得する
   * @returns
   */
  export function fetchProducerList(): Promise<any[]> {
    let componentService = new ComponentService(new ShowDefaultDialogService(), new MessageService());
    let dtService = new DataTransmissionService(componentService);

    const condition = {
      columns: ['Email', 'UserName', 'ApplicationRole'],
      defaultRole: GocooEngineConfig.environment.applicationUser.defaultRole,
    };

    return new Promise((resolve, reject) => {
      const callBack = (response: ResponseDataModel) => {
        if (!response.isCompleted) {
          resolve([]);
        }

        resolve(response.data.DataList);
      };
      dtService.fetchApplicationUserList(condition, callBack);
    });
  }

  /**
   * アプリケーションユーザーのマネージャーリストを取得する
   * @returns <any[]> アプリケーションユーザーのマネージャーリスト
   */
  export function fetchManagerList(): Promise<any[]> {
    let componentService = new ComponentService(new ShowDefaultDialogService(), new MessageService());
    let dtService = new DataTransmissionService(componentService);

    const condition = {
      columns: ['Email', 'UserName', 'ApplicationRole'],
      defaultRole: GocooEngineConfig.environment.applicationUser.defaultRole,
    };
    return new Promise((resolve, reject) => {
      const callBack = (response: ResponseDataModel) => {
        if (!response.isCompleted) {
          resolve([]);
        }

        if (response.data.DataList.length === 0) resolve([]);
        let managerList = (response.data.DataList as any[]).filter(
          (user: any) => user.ApplicationRole === UserRole.ProductionManager
        );
        resolve(managerList);
      };
      dtService.fetchApplicationUserList(condition, callBack);
    });
  }
}

export enum UserRole {
  Legal = 'Legal',
  ProductionManager = 'ProductionManager',
  Production = 'Production',
}
